import { useMemo, useState } from "react";
import { number, object, string } from "prop-types";
import { observer } from "mobx-react";
import { DragDropProvider, DragOverlay } from "@dnd-kit/react";
import { DragDropManager } from "@dnd-kit/dom";
import {
  useVisibilityModeCellClassName,
  useEstimateTableSettings,
  useEstimateEditorStore,
  HeaderRow,
  PinnableCell,
  VisibilityButton,
} from "@tools";
import { DragDropManagerModifierSetup, DragDropManagerPluginSetup, DragDropManagerSensorSetup } from "@components";
import { Grid } from "@material-ui/core";
import { SectionCell } from "./components/SectionCell";
import { TimelineSectionBar } from "./components/TimelineSectionBar/TimelineSectionBar";
import classnames from "classnames";

export const TimelineSectionsRow =  observer(({
  index,
  section,
  // tableContainerIdentifier,
}) => {
  const { visibilityMode } = useEstimateEditorStore();
  const { timelineLength } = useEstimateTableSettings();
  
  const [ isDragging, setIsDragging ] = useState();
  
  const {
    id,
    timelineStartWeek,
    timelineStartMonth,
    hideOnTimeline,
  } = section;
  
  const manager = useMemo(() => (
    new DragDropManager({
      sensors: DragDropManagerSensorSetup(true),
      modifiers: DragDropManagerModifierSetup(true, true),
      plugins: DragDropManagerPluginSetup,
    })
  ));
  
  const className = useVisibilityModeCellClassName(hideOnTimeline);
  
  const handleDragStart = () => setIsDragging(true);
  const handleDragEnd = (event) => {
    const { operation, canceled } = event;
    
    if(!canceled)
      section.setTimelineStartWeek(operation?.target?.data.week);
    
    setIsDragging(false);
  };
  
  // const scrollHandler = (el) => {
  //   return el?.id === tableContainerIdentifier;
  // }
  
  return (
    <HeaderRow
      size="medium"
      className={classnames("preset-paperTimeline", className)}
      actionPresetClass="preset-paperTimeline"
    >
      <PinnableCell
        boldText
        colName="title"
        pinnedLeft
        hasStaticWidth
        size="medium"
        isHeader
        allowOverflowDisplay
        actions={
          visibilityMode &&
          <VisibilityButton hidden={hideOnTimeline} onChange={section.setHideOnTimeline} />
        }
      />
      <Grid item container wrap="nowrap" className="month-container">
        <DragDropProvider
          manager={manager}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
        >
          {
            [...new Array(timelineLength).keys()]
              .map((_, i) => (
                <SectionCell
                  key={i}
                  sectionId={id}
                  monthIndex={i}
                  startWeek={timelineStartWeek}
                >
                  {
                    timelineStartMonth === i &&
                    <TimelineSectionBar
                      index={index}
                      section={section}
                      isPlaceholder={isDragging}
                    />
                  }
                </SectionCell>
              ))
          }
          <DragOverlay>
            {
              isDragging &&
              <TimelineSectionBar
                index={index}
                section={section}
                isDraggable
              />
            }
          </DragOverlay>
        </DragDropProvider>
      </Grid>
    </HeaderRow>
  );
});

TimelineSectionsRow.propTypes = {
  section: object.isRequired,
  index: number,
  tableContainerIdentifier: string,
};